import * as React from "react";
import { forwardRef } from "react";
const SvgWave = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.0007 3.33398V16.6673M16.6673 8.33398V11.6673M3.33398 8.33398V11.6673M13.334 5.83398V14.1673M6.66732 5.83398V14.1673", stroke: "#1A2023", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgWave);
export { ForwardRef as ReactComponent };
